import {gsap} from "gsap";
import {NineToFiveGameAssets} from "../NineToFiveGameAssets";
import {NineToFive} from "../NineToFive";
import {start} from "repl";

export class FreespinMultiplier extends PIXI.Container {
    public multiplier:number;
    private visualMultiplier:number;
    private multiplierText:PIXI.BitmapText;
    public nextMultiplier:number;
    private visualNextMultiplier:number;
    private nextMultiplierText:PIXI.BitmapText;
    private nextMultiplierContainer:PIXI.Container;
    private fsPacer:PIXI.Sprite;
    private fsPacerText: PIXI.Text;
    private sfsPacer:PIXI.Sprite;
    private sfsPacerText: PIXI.Text;

    constructor() {
        super();
        this.multiplier = 1;
        this.visualMultiplier = 1;
        this.multiplierText = new PIXI.BitmapText(this.formatCurrent(), {
            fontName : NineToFiveGameAssets.BITMAP_FONT_FS_MULTI,
            fontSize : 40,
        });
        // why do I need to cast this?
        (<PIXI.Point>this.multiplierText.anchor).set(1, 0.5);
        this.multiplierText.position.set(10, 0);

        this.nextMultiplierContainer = new PIXI.Container();
        this.nextMultiplierContainer.position.set(90,5);
        const nextMultiMask = new PIXI.Graphics();
        nextMultiMask.beginFill();
        //nextMultiMask.drawRect(-21, -72, 145, 43);
        nextMultiMask.drawRect(-51, -27, 145, 43);
        this.nextMultiplierContainer.addChild(nextMultiMask);
        this.nextMultiplierContainer.mask = nextMultiMask;

        this.nextMultiplier = 1;
        this.visualNextMultiplier = 1;
        this.nextMultiplierText = new PIXI.BitmapText(this.formatNext(), {
            fontName : NineToFiveGameAssets.BITMAP_FONT_FS_MULTI,
            fontSize : 30,
        });
        // why do I need to cast this?
        (<PIXI.Point>this.nextMultiplierText.anchor).set(1, 0.5);
        this.nextMultiplierText.position.set(90, 3);
        this.nextMultiplierText.alpha = 0.35;
        this.nextMultiplierContainer.addChild(this.nextMultiplierText);

        this.fsPacer = new PIXI.Sprite(NineToFive.assetLoader.getTextures(NineToFiveGameAssets.FS_MULTI_PACER)[0]);
        this.fsPacer.anchor.set(0.5, 0.5);
        this.fsPacer.visible = false;
        this.fsPacerText = new PIXI.Text(NineToFive.apiPlugin.translations.translate("NEXT"), {
            dropShadow: true,
            dropShadowAngle: 7.9,
            dropShadowBlur: 1,
            dropShadowColor: "#FFFFFF",
            dropShadowDistance: 2,
            fill: "#516973",
            fontFamily: "Helvetica",
            fontSize: 14,
            fontWeight: "bolder",
            miterLimit: 0,
            stroke: "#516973"
        });
        this.fsPacerText.anchor.set(0.5, 0.5);
        this.fsPacerText.position.set(115, -32);
        this.fsPacerText.visible = false;

        this.sfsPacer = new PIXI.Sprite(NineToFive.assetLoader.getTextures(NineToFiveGameAssets.SFS_MULTI_PACER)[0]);
        this.sfsPacer.anchor.set(0.5, 0.5);
        this.sfsPacer.visible = false;
        this.sfsPacerText = new PIXI.Text(NineToFive.apiPlugin.translations.translate("NEXT"), {
            dropShadow: true,
            dropShadowAngle: 7.9,
            dropShadowBlur: 1,
            dropShadowColor: "#29273A",
            dropShadowDistance: 2,
            fill: "#CCCCFF",
            fontFamily: "Helvetica",
            fontSize: 14,
            fontWeight: "bolder",
            miterLimit: 0,
            stroke: "#516973"
        });
        this.sfsPacerText.anchor.set(0.5, 0.5);
        this.sfsPacerText.position.set(115, -32);
        this.sfsPacerText.visible = false;

        this.addChild(this.fsPacer);
        this.addChild(this.fsPacerText);
        this.addChild(this.sfsPacer);
        this.addChild(this.sfsPacerText);
        this.addChild(this.multiplierText);
        this.addChild(this.nextMultiplierContainer);
    }

    private formatCurrent():string {
        return `x${this.visualMultiplier}`;
    }

    private formatNext():string {
        return `+${this.visualNextMultiplier}`;
    }

    // FS
    public increment(): gsap.core.Timeline {
        this.multiplier++;
        return gsap.timeline()
            .add(() => {
                this.visualMultiplier++
                this.multiplierText.text = this.formatCurrent();
            })
            .add(() => {}, '>0.3');
    }

    public decrement(): gsap.core.Timeline {
        const cantGoLower = this.multiplier == 1;
        this.multiplier = Math.max(this.multiplier - 1, 1);
        return cantGoLower
            ? gsap.timeline()
                .add(() => {
                    this.multiplierText.text = "ERR";
                })
                .add(() => {}, '>0.6')
                .add(() => {
                    this.multiplierText.text = this.formatCurrent();
                })
                .add(() => {}, '>0.3')
            : gsap.timeline()
                .add(() => {
                    this.visualMultiplier--;
                    this.multiplierText.text = this.formatCurrent();
                })
                .add(() => {}, '>0.3');
    }

    // SFS
    public incrementSfsNext(): gsap.core.Timeline {
        this.nextMultiplier = Math.min(9999, this.nextMultiplier * 2);
        const targetMultiplier = this.nextMultiplier
        return gsap.timeline()
            .add(() => {
                this.visualNextMultiplier = targetMultiplier;
                this.nextMultiplierText.text = this.formatNext();
                this.nextMultiplierText.position.set(90, 3);
            })
            .add(() => {}, '>0.3');
    }

    public decrementSfsNext(): gsap.core.Timeline {
        const cantGoLower = this.nextMultiplier < 4;
        this.nextMultiplier = Math.max(Math.floor(this.nextMultiplier / 4), 1);
        // state :vomit:
        const targetMultiplier = this.nextMultiplier;
        return cantGoLower
            ? gsap.timeline()
                .add(() => {
                    this.nextMultiplierText.text = "ERR";
                })
                .add(() => {}, '>0.6')
                .add(() => {
                    this.visualNextMultiplier = targetMultiplier;
                    this.nextMultiplierText.text = this.formatNext();
                })
                .add(() => {}, '>0.3')
            : gsap.timeline()
                .add(() => {
                    this.visualNextMultiplier = targetMultiplier
                    this.nextMultiplierText.text = this.formatNext();
                })
                .add(() => {}, '>0.3');
    }

    public addNextToCurrent(): gsap.core.Timeline {
        const isAlreadyMaxed = this.multiplier == 9999;
        this.multiplier = Math.min(9999, this.multiplier += this.nextMultiplier);
        const targetMultiplier = this.multiplier;
        return !isAlreadyMaxed
               ? gsap.timeline()
                   .add(() => {
                       this.nextMultiplierText.position.x -= 25;
                   })
                   .add(() => {
                       this.nextMultiplierText.position.x -= 25;
                   }, '>0.05')
                   .add(() => {
                       this.nextMultiplierText.position.x -= 25;
                   }, '>0.05')
                   .add(() => {
                       this.nextMultiplierText.position.x -= 25;
                   }, '>0.05')
                   .add(() => {
                       this.nextMultiplierText.position.x -= 25;
                   }, '>0.05')
                   .add(() => {
                       this.nextMultiplierText.position.x -= 25;
                   }, '>0.05')
                   .add(() => {
                       this.visualMultiplier = targetMultiplier;
                       this.multiplierText.text = this.formatCurrent();
                   }, '>0.2')
                   .add(() => {}, '>0.3')
               : gsap.timeline();
    }

    public reset(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.nextMultiplier = 1;
                this.visualNextMultiplier = this.nextMultiplier
                this.nextMultiplierText.text = this.formatNext();
                this.multiplier = 1;
                this.visualMultiplier = this.multiplier
                this.multiplierText.text = this.formatCurrent();
            })
    }

    public setVisualToFreespins(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.nextMultiplierText.alpha = 0.35;
                this.fsPacer.visible = true;
                this.fsPacerText.visible = true;
                this.sfsPacer.visible = false;
                this.sfsPacerText.visible = false;
            })
    }

    public setVisualToSuperFreespins(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.nextMultiplierText.alpha = 1;
                this.fsPacer.visible = false;
                this.fsPacerText.visible = false;
                this.sfsPacer.visible = true;
                this.sfsPacerText.visible = true;
            })
    }

    public restore(multiplier:number, nextMultiplier:number):void {
        this.multiplier = multiplier;
        this.visualMultiplier = this.multiplier;
        this.multiplierText.text = this.formatCurrent();
        this.nextMultiplier = nextMultiplier;
        this.visualNextMultiplier = this.nextMultiplier;
        this.nextMultiplierText.text = this.formatNext();
    }
}
